import {
  Control,
  FilterValues,
  ListFilterState,
  ReadFilterState,
} from "./types";

export default <TFilterValues extends FilterValues>(
  formState: ListFilterState<TFilterValues>,
  control: Control<TFilterValues>,
  localProxyFormState?: ReadFilterState
) => {
  const result = {
    defaultValues: control._defaultValues,
  } as typeof formState;

  for (const key in formState) {
    Object.defineProperty(result, key, {
      get: () => {
        const _key = key as keyof ListFilterState<TFilterValues> &
          keyof ReadFilterState;
        localProxyFormState && (localProxyFormState[_key] = true);
        return formState[_key];
      },
    });
  }

  return result;
};
